var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.857,
    y1: 0.173,
    x2: 0.219,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b6bb20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 21,
    ry: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 20,
    ry: 20.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,39A18.634,18.634,0,0,1,5.565,33.289a19.864,19.864,0,0,1,0-27.577,18.657,18.657,0,0,1,26.87,0,19.865,19.865,0,0,1,0,27.577A18.636,18.636,0,0,1,19,39ZM7.918,26.762h0a18.466,18.466,0,0,0,7.524,1.776c4.36,0,10.038-2.078,12.333-11.98a9.411,9.411,0,0,1,0-1.331A20.624,20.624,0,0,0,29.98,13.01l-2.206.443c.913-.367,1.224-1.961,1.326-2.485a.99.99,0,0,1,.04-.176l-2.2,1.33c-.007-.018-.691-1.775-3.75-1.775a4.652,4.652,0,0,0-4.634,4.659,3.46,3.46,0,0,0,.089.976l-.442.089A11.961,11.961,0,0,1,11.287,13.5a8.964,8.964,0,0,1-2.046-2.268c-1.8,1.851.587,5.221,1.7,6.583l.023.028A4.638,4.638,0,0,1,8.8,17,4.645,4.645,0,0,0,9,18.871a3.851,3.851,0,0,0,2.884,2.568h0l0,0a1.39,1.39,0,0,1-1.1.6,1.58,1.58,0,0,1-.663-.159,3.331,3.331,0,0,0,.761,1.158,5.43,5.43,0,0,0,3.21,1.5,2.139,2.139,0,0,1-.887,1.112c-.7.507-2.114,1.112-4.83,1.112C8.228,26.767,8.074,26.765,7.918,26.762Z",
    transform: "translate(4 4)",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.05abdb58918b77d3bcf73bd85cf221b0.svg";
export { ForwardRef as ReactComponent };